<div class="ol-container">
  <div class="ol-left-block">
    <div class="ol-title-wrapper"></div>
  </div>
  <div class="ol-login-block">
    <div class="ol-login-form-wrapper">
      <div class="ol-logo-wrapper">
        <img class="ol-packt-logo" src="../../../../../assets/packt-log.svg" />
        <p class="ol-title-text">Onelog</p>
      </div>
      <form class="ol-login-form">
        <label class="ol-access-token-title">Enter Access Token</label>
        <input
          type="text"
          class="form-control ol-access-token-txt"
          [(ngModel)]="accessToken"
          id="access_token"
          placeholder=""
          name="accessToken"
        />
        <button
          type="submit"
          class="btn btn-primary ol-btn"
          (click)="login()"
          [disabled]="accessToken == ''"
        >
          Login
        </button>
        <br />
        <button
          class="btn btn-primary mt-2"
          (click)="microsoftLogin()"
          style="background-color: #4052ab;"
        >
          Login with Microsoft
        </button>
        <br />
      </form>
    </div>
  </div>
</div>
